module.exports = __webpack_public_path__ + "img/entrega.20138f6e.svg";